import { useEffect } from 'react'

import { TaxonomyType } from 'generated/graphql'
import { useWorkspaceCompanyPlan } from 'hooks/useWorkspaceCompanyPlan'

import { WORKSPACE_GET_COMPANY_PLAN_LOG_ERROR } from './search-territory-page-selector.consts'
import type { ISearchTerritoryPageSelector } from './search-territory-page-selector.types'

export const useSearchTerritoryPageSelectorModel = (): ISearchTerritoryPageSelector => {
  const {
    workspaceTaxonomyType,
    getWorkspaceCompanyPlanFromApi,
    workspaceCompanyPlanLoading,
    workspaceCompanyPlanCalled,
  } = useWorkspaceCompanyPlan({
    errorLog: WORKSPACE_GET_COMPANY_PLAN_LOG_ERROR,
  })

  const isGlobalTaxonomyWorkspace = workspaceTaxonomyType === TaxonomyType.Country
  const isQueryInformationAvailable = workspaceCompanyPlanCalled && !workspaceCompanyPlanLoading

  useEffect(() => {
    getWorkspaceCompanyPlanFromApi()
  }, [getWorkspaceCompanyPlanFromApi])

  return { isGlobalTaxonomyWorkspace, isQueryInformationAvailable }
}
